/* eslint-disable */

import { tns } from "tiny-slider/src/tiny-slider"

export default {
    init() {
        // JavaScript to be fired on the home page
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
        if($('.companies').length != 0){
            tns({
                container: '.companies',
                items: 3,
                slideBy: 'page',
                autoplay: true,
                gutter: 32,
                mouseDrag: true,
                nextButton: '.next',
                prevButton: '.prev',
                responsive: {
                    640: {
                        items: 2
                    },
                    700: {
                        items: 4
                    },
                    900: {
                        items: 5
                    }
                }
            });
        }
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-businesses.js